import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './Discover.module.sass'
import Slider from 'react-slick'
import Icon from '../../../components/Icon'
import Card from '../../../components/Card'
import Dropdown from '../../../components/Dropdown'
import { get, prepareItems } from '../../../adapters/api'
import { Slider as Sliderrange } from 'antd'
import { fromWei } from 'web3-utils'
import config from '../../../config'

const tokensAgeOptions = ['By publishing date', 'Newest', 'Oldest']
const priceOptions = ['By token price', 'Cheapest', 'Most Expensive']
const videoOptions = ['Token media type', 'Short fims', 'Music', 'Movies', 'Images']

const sortingOptions = []

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
)

const Discover = () => {
  const [activeIndex, setActiveIndex] = useState(false)
  const [tokensAge, setTokensAge] = useState(tokensAgeOptions[0])
  const [priceDD, setPriceDD] = useState(priceOptions[0])
  const [sorting, setSorting] = useState(sortingOptions[0])
  const [videoDD, setVideoDD] = useState(videoOptions[0]) // filter by video dropdown
  const [visible, setVisible] = useState(false)
  const [priceRange, setPriceRange] = useState(false)
  const [data, setData] = useState()
  const [searchInCat, setSearchInCat] = useState('All') //filter by category
  const [searchFilters, setSearchFilters] = useState() //trigger for useEffect
  const [selectedPriceMin, setSelectedPriceMin] = useState(false) //trigger for useEffect
  const [selectedPriceMax, setSelectedPriceMax] = useState(false) //trigger for useEffect

  const STEP = 0.1

  useEffect(() => {
    const fl = {}

    if (tokensAge !== tokensAgeOptions[0]) {
      fl.tokensAge = tokensAge
    }
    if (priceDD !== priceOptions[0]) {
      fl.priceDD = priceDD
    }
    if (videoDD !== videoOptions[0]) {
      fl.typeContent = videoDD
    }
    if (searchInCat !== 'All') {
      fl.searchInCat = searchInCat
    }
    if (priceRange) {
      fl.priceRange = priceRange
    }

    setSearchFilters(fl)

  }, [priceDD, videoDD, tokensAge, searchInCat, priceRange])

  //fix to new search params
  useEffect(() => {
    (async () => {
      if (searchFilters) {
        const params = prepareParams()

        const info = await get('token/discover?' + params)
        console.log('discover', info)
        if (info.data) {
          info.data.items = prepareItems(info.data.items, info.data.users)
          info.data.filters.minPrice = Math.floor(info.data.filters.minPrice ? fromWei(`${info.data.filters.minPrice}0000000000`, 'ether') : 0)
          info.data.filters.maxPrice = Math.ceil(info.data.filters.maxPrice ? fromWei(`${info.data.filters.maxPrice}0000000000`, 'ether') : 1)
          setData(info.data)
          if (!selectedPriceMin) {
            setSelectedPriceMin(info.data.filters.minPrice)
          }
          if (!selectedPriceMax) {
            setSelectedPriceMax(info.data.filters.maxPrice)
          }
        }
      }
    })()
  }, [searchFilters])

  const prepareParams = () => {
    return new URLSearchParams(searchFilters).toString()
  }

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-next" size="14"/>
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-prev" size="14"/>
      </SlickArrow>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 100000,
        settings: 'unslick',
      },
    ],
  }

  function onRangeChange (value) {
    setSelectedPriceMin(value[0])
    setSelectedPriceMax(value[1])
  }

  function onRangeAfterChange (value) {
    setPriceRange(value)
  }

  const handleAgeChange = (val) => {
    setTokensAge(val)
    setPriceDD(priceOptions[0])
  }

  const handlePriceDD = (val) => {
    setTokensAge(tokensAgeOptions[0])
    setPriceDD(val)
  }

  const handleVideoDD = (val) => {
    setVideoDD(val)
  }

  return (
    <div className={cn('section', styles.section)}>
      <div className={cn('container', styles.container)}>
        <h3 className={cn('h3', styles.title)}>Discover</h3>
        <div className={styles.top}>
          <div className={styles.nav}>
            <button className={cn(styles.link, { [styles.active]: searchInCat === 'All' })} onClick={() => {
              setActiveIndex(false)
              setSearchInCat('All')
            }}>All
            </button>
            {data && data.categories.map((x, index) => (
              <button
                className={cn(styles.link, {
                  [styles.active]: index === activeIndex,
                })}
                onClick={() => {
                  setActiveIndex(index)
                  setSearchInCat(x.category)
                }}
                key={index}
              >
                {x.category}
              </button>
            ))}
          </div>
          <div className={cn('tablet-show', styles.dropdown)}>
            <Dropdown
              className={styles.dropdown}
              value={sorting}
              setValue={setSorting}
              options={sortingOptions}
            />
          </div>
          <button
            className={cn(styles.filter, { [styles.active]: visible })}
            onClick={() => setVisible(!visible)}
          >
            <div className={styles.text}>Filter</div>
            <div className={styles.toggle}>
              <Icon name="filter" size="18"/>
              <Icon name="close" size="10"/>
            </div>
          </button>
        </div>
        <div className={cn(styles.filters, { [styles.active]: visible })}>
          <div className={styles.sorting}>
            <div className={styles.cell}>
              <div className={styles.label}>Price</div>
              <Dropdown
                className={styles.dropdown}
                value={priceDD}
                setValue={handlePriceDD}
                options={priceOptions}
              />
            </div>

            <div className={styles.cell}>
              <div className={styles.label}>Date</div>
              <div className={styles.dropdown}>
                <Dropdown
                  className={styles.dropdown}
                  value={tokensAge}
                  setValue={handleAgeChange}
                  options={tokensAgeOptions}
                />
              </div>
            </div>

            <div className={styles.cell}>
              <div className={styles.label}>Price range</div>

              {data && <Sliderrange
                range
                min={parseFloat(data.filters.minPrice)}
                max={parseFloat(data.filters.maxPrice)}
                step={STEP}
                defaultValue={[data.filters.minPrice, data.filters.maxPrice]}
                onChange={onRangeChange}
                onAfterChange={onRangeAfterChange}
              />}

              <div className={styles.scale}>
                <div
                  className={styles.number}>{selectedPriceMin}&nbsp;{config.symbolName}</div>
                <div
                  className={styles.number}>{selectedPriceMax}&nbsp;{config.symbolName}</div>
              </div>
            </div>

            <div className={styles.cell}>
              <div className={styles.label}>Filter by</div>
              <Dropdown
                className={styles.dropdown}
                value={videoDD}
                setValue={handleVideoDD}
                options={videoOptions}
              />
            </div>
          </div>
        </div>
        <div className={styles.list}>
          <Slider
            className={cn('discover-slider', styles.slider)}
            {...settings}
          >
            {data && data.items.map((x, index) => (
              <Card className={styles.card} item={x} key={index} users={data.users}/>
            ))}
          </Slider>
        </div>
        <div className={styles.btns}>
          <a className={cn('button-stroke button-small', styles.button)}
             href={'/search'}>
            <span>Load more</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Discover;
